/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { SellerBillingInfoDTOFromJSON, SellerBillingInfoUpdateDTOToJSON, UserDTOFromJSON, UserUpdateDTOToJSON, } from '../models/index';
/**
 *
 */
export class UserControllerApi extends runtime.BaseAPI {
    /**
     */
    async getCurrentUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/users/me`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UserDTOFromJSON(jsonValue));
    }
    /**
     */
    async getCurrentUser(initOverrides) {
        const response = await this.getCurrentUserRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getSellerBillingInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/users/me/billing-info`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SellerBillingInfoDTOFromJSON(jsonValue));
    }
    /**
     */
    async getSellerBillingInfo(initOverrides) {
        const response = await this.getSellerBillingInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async partialUpdateUserRaw(requestParameters, initOverrides) {
        if (requestParameters['userUpdateDTO'] == null) {
            throw new runtime.RequiredError('userUpdateDTO', 'Required parameter "userUpdateDTO" was null or undefined when calling partialUpdateUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/users`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateDTOToJSON(requestParameters['userUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UserDTOFromJSON(jsonValue));
    }
    /**
     */
    async partialUpdateUser(requestParameters, initOverrides) {
        const response = await this.partialUpdateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateSellerBillingInfoRaw(requestParameters, initOverrides) {
        if (requestParameters['sellerBillingInfoUpdateDTO'] == null) {
            throw new runtime.RequiredError('sellerBillingInfoUpdateDTO', 'Required parameter "sellerBillingInfoUpdateDTO" was null or undefined when calling updateSellerBillingInfo().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/users/me/billing-info`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SellerBillingInfoUpdateDTOToJSON(requestParameters['sellerBillingInfoUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SellerBillingInfoDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateSellerBillingInfo(requestParameters, initOverrides) {
        const response = await this.updateSellerBillingInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
